<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn color="primary" x-small text @click="() => $router.push({ name: 'home' })">
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Planos
          <span class="meu-componente-especial">
            <e-help-tooltip :text="$constants.tooltips.planos.listarPlanos" />
          </span>
        </h1>
      </v-col>
    </v-row>

    <v-row v-if="canListarEAprovarPlanos">
      <v-col cols="12">
        <v-form>
          <v-card>
            <div class="text-start py-2 px-4 text-button">Pesquisa avançada</div>

            <v-divider class="theme--light"></v-divider>
            <v-row class="px-4 mt-4">
              <v-col>
                <v-text-field
                  v-model="professor"
                  label="NOME ou CPF Professor"
                  outlined
                  dense
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="d-flex justify-space-between mb-6 px-4">
              <v-col cols="12" sm="6" md="4">
                <v-autocomplete
                  :items="disciplinas"
                  :return-object="false"
                  v-model="disciplina"
                  label="Escolha um componente curricular"
                  item-text="descricao"
                  item-value="descricao"
                  outlined
                  dense
                  clearable
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-autocomplete
                  :items="turmas"
                  :return-object="false"
                  v-model="turma"
                  label="Escolha uma turma"
                  item-text="descricao"
                  item-value="descricao"
                  outlined
                  dense
                  clearable
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" md="4" s>
                <v-autocomplete
                  :items="etapasList"
                  :return-object="false"
                  v-model="etapa_id"
                  label="Escolha uma etapa"
                  item-text="descricao"
                  item-value="id"
                  outlined
                  dense
                  clearable
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="12" md="12" class="mb-5">
                <v-btn color="primary" block @click="() => limparCampos()">Limpar filtros</v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-form>
      </v-col>

      <v-col>
        <v-data-table
          :loading="carregando"
          :headers="table.headers"
          :items="planos"
          :items-per-page="15"
          hide-default-footer
          class="elevation-1"
        >
          <template v-slot:body="{ items }">
            <tbody
              name="scroll-x-transition"
              is="transition-group"
              duration="150"
              v-if="items.length > 0"
            >
              <tr color="primary" v-for="plano of items" :key="plano.id">
                <td>{{ plano.id ? plano.id : "- - -" }}</td>
                <td>
                  {{ plano.gestao_de_aula.professor.nome }}
                </td>
                <td>{{ plano.gestao_de_aula.turma.descricao }}</td>
                <td>
                  <!-- {{ plano.status ? plano.status : "----" }} -->
                  <e-situacao-plano
                    :plano="plano"
                    @update="(e) => [carregarDadosAoAtualizarStatus(e)]"
                  />
                </td>
                <td>
                  {{ plano.etapa.descricao }}
                </td>
                <td>{{ plano.disciplina?.descricao }}</td>
                <td>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="
                          () =>
                            $router.push({
                              name: 'gestoesDeAulas.planosVisualizar',
                              params: { id: plano.id },
                            })
                        "
                        x-small
                        class="ml-1"
                        v-bind="attrs"
                        color="orange"
                        v-on="on"
                      >
                        <v-icon small>mdi-note-text-outline </v-icon>
                      </v-btn>
                    </template>
                    <span>Visualizar</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="() => [visualizarPdf(plano.id)]"
                        x-small
                        class="ml-1"
                        v-bind="attrs"
                        color="orange"
                        v-on="on"
                      >
                        <v-icon small>mdi-note </v-icon>
                      </v-btn>
                    </template>
                    <span>Visualizar Pdf</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>

            <tbody v-else>
              <tr>
                <td :colspan="table.headers.length" class="text-center pa-6">
                  <div>
                    <v-icon large color="grey lighten-1" class="mb-4">
                      mdi-folder-open-outline
                    </v-icon>
                    <div class="text-h6 grey--text text--darken-1 mb-2">
                      Nenhum plano encontrado
                    </div>
                    <div class="grey--text">Não há planos de aula cadastrados para exibir.</div>
                  </div>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>

        <e-paginate
          :current_page="paginate.current_page"
          :last_page="paginate.last_page"
          :pageNumber="pageNumber"
          @changeActionResponse="carregarPlanos"
          :search="search"
        >
        </e-paginate>
      </v-col>
    </v-row>

    <v-row v-else>
      <v-col cols="12" class="pa-4">
        <v-alert type="error" dense> Você não tem permissão para visualizar esse recurso.</v-alert>
      </v-col>
    </v-row>

    <ModalCarteira
      :dialog="dialog"
      :pdf="pdf"
      @close="fecharVisualizacaoPdf"
      v-on:update="carregarDadosAoAtualizarStatus"
    />
  </main-template>
</template>

<script>
import { dataTableFilter } from "@/plugins/searchQuery";
import ModalCarteira from "@/components/Matriculas/EModalCarteira.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    ModalCarteira,
  },
  watch: {
    async professor(value) {
      value = this.formatarCPf(value);
      this.professor = value;
      await this.carregarPlanos();
    },
    async turma(value) {
      this.turma = value;
      await this.carregarPlanos();
    },
    async disciplina(value) {
      this.disciplina = value;
      await this.carregarPlanos();
    },
    async mes(value) {
      this.mes = value;
      await this.carregarPlanos();
    },
    async etapa_id(value) {
      this.etapa_id = value;
      await this.carregarPlanos();
    },
  },
  data() {
    return {
      carregando: false,
      dialog: false,
      pdf: null,
      disciplinas: [],
      meses: [],
      turmas: [],
      planos: [],
      professor: "",
      turma: "",
      disciplina: "",
      etapa_id: "",
      mes: "",
      dataTableFilter,
      search: "",
      pageNumber: 1,
      paginate: {
        current_page: 1,
        last_page: 1,
      },
      table: {
        headers: [
          { text: "#", value: "id" },
          { text: "Professor", value: "gestao_de_aula.professor.nome" },
          { text: "Turma", value: "gestao_de_aula.turma.descricao" },
          { text: "Status", value: "status" },
          { text: "Período", value: "etapa.descricao" },
          { text: "Disciplina", value: "gestao_de_aula.disciplina.descricao" },
          { text: "Ações", value: "actions", sortable: false },
        ],
      },
      etapasList: [],
    };
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    canListarEAprovarPlanos() {
      try {
        return this.user.permissions.includes("planosBimestrais.aprovar");
      } catch (error) {
        this.$handleError(error);
        return false;
      }
    },
  },
  async mounted() {
    this.carregarDados();
  },
  methods: {
    async carregarDados() {
      this.carregarPlanos(this.pageNumber);
      this.listarDisciplinas();
      this.listarTurmas();
      this.listarDisciplinas();
      // this.listarMeses();
    },

    async listarDisciplinas() {
      try {
        const { data } = await this.$services.planosService.disciplinas();
        this.disciplinas = data;
      } catch (error) {
        this.$handleError(error);
      }
    },
    async listarTurmas() {
      try {
        const { data } = await this.$services.planosService.turmas();
        const result = data.map((t) => {
          const local = { ...t };
          return (local.descricao = `${t.descricao} (${t.franquia.descricao})`);
        });
        this.turmas = result;
      } catch (error) {
        this.$handleError(error);
      }
    },
    // async listarMeses() {
    //   try {
    //     const { data } = await this.$services.planosService.meses();
    //     this.meses = data;
    //   } catch (error) {
    //     this.$handleError(error);
    //   }
    // },
    async carregarPlanos(numeroDaPagina = null) {
      this.paginate.current_page = numeroDaPagina || this.pageNumber;
      this.pageNumber = numeroDaPagina || this.pageNumber;
      try {
        this.dialog = false;
        this.carregando = true;
        const payload = await this.$services.planosService.index(
          this.pageNumber,
          this.professor,
          this.turma,
          this.disciplina,
          this.etapa_id,
          this.periodo
        );
        this.planos = payload.planos;
        this.paginate = payload.data;
        this.carregando = false;
      } catch (error) {
        this.$handleError(error);
      }
    },
    async carregarDadosAoAtualizarStatus(plano) {
      try {
        this.carregarPlanos();
      } catch (error) {
        this.$handleError(error);
      }
    },
    limparCampos() {
      this.professor = "";
      this.turma = "";
      this.disciplina = "";
      this.mes = "";
      this.etapa_id = "";
    },
    formatarCPf(value) {
      if (!value) return "";
      value = value.replace("-", "");
      value = value.replace(".", "");
      return value;
    },
    async visualizarPdf(planoId) {
      this.$loaderService.open("Carregando Plano");
      try {
        this.pdf = await this.$services.planosService.pdf(planoId);
        this.dialog = true;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    fecharVisualizacaoPdf() {
      this.pdf = null;
      this.dialog = false;
    },
    fecharVisualizacaoPdf() {
      this.pdf = null;
      this.dialog = false;
    },
  },
};
</script>
<style></style>
